// Search.jsx
import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'

export function Search(props) {
    const dispatch = useDispatch()
    const searchTimeoutRef = useRef(null)
    const [searchName, setSearchName] = useState('')

    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) {
                clearTimeout(searchTimeoutRef.current)
            }
        }
    }, [])

    const searchChangeHandler = (e) => {
        const value = e.target.value

        setSearchName(value)

        if (typeof props.setSearchMainName === 'function') {
            props.setSearchMainName(value)
        }

        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current)
            searchTimeoutRef.current = null
        }

        if (typeof props.setPageNumber === 'function') {
            const pageAction = props.setPageNumber(0)
            if (pageAction && typeof pageAction === 'object' && pageAction.type) {
                dispatch(pageAction)
            }
        }

        if (props.productSort && typeof props.search === 'function') {
            const nextAdditionalData = {
                ...(props.additionalData || {}),
                pageNumber: 0,
            }

            if (value !== '') {
                searchTimeoutRef.current = setTimeout(() => {
                    dispatch(props.search(
                        value,
                        props.sortType || 'createdAtMinus',
                        props.sortSearch,
                        nextAdditionalData
                    ))
                }, 700)
            } else {
                dispatch(props.search(
                    '',
                    props.sortType || 'createdAtMinus',
                    props.sortSearch,
                    nextAdditionalData
                ))
            }

            return
        }

        if (value !== '') {
            searchTimeoutRef.current = setTimeout(() => {
                if (typeof props.search === 'function') {
                    dispatch(props.search(
                        value,
                        props.sortType || 'createdAtMinus',
                        props.sortSearch,
                        props.additionalData
                    ))
                }
            }, 700)

            return
        }

        if (typeof props.get === 'function') {
            dispatch(props.get(
                props.sortType || 'createdAtMinus',
                props.pageNumber || 0,
                props.pageSize || 20,
                undefined,
                props.additionalData
            ))
        }
    }

    return (
        <input
            className={['disk__search', props.className].filter(Boolean).join(' ')}
            type="search"
            placeholder={props.placeholder || 'Поиск'}
            aria-label={props.ariaLabel || props.placeholder || 'Поиск'}
            autoComplete="off"
            value={searchName}
            onChange={searchChangeHandler}
        />
    )
}
